import React, { PureComponent } from "react";
import styles from "./logs.module.less"
import { Divider } from "antd"
import AlarmLog from "./AlarmLog";
import ActionLog from "./ActionLog";
import EventLog from "./EventLog";
import OtherLog from "./OtherLog";
import classnames from 'classnames';


class Logs extends PureComponent {
    state = {
        selectType: `alarm`,
    };

    typeChange = (type) => {
        this.setState({ selectType: type });
    }

    render() {
        const { selectType } = this.state;
        let log = undefined;
        switch (selectType) {
            case `alarm`:
                log = (<AlarmLog {...this.props} />);
                break;
            case `event`:
                log = (<EventLog {...this.props} />);
                break;
            case `action`:
                log = (<ActionLog {...this.props} />);
                break;
            case `other`:
                log = (<OtherLog {...this.props} />);
                break;
            default:
                break;
        }

        return (
            <div className={styles.main}>
                <div className={styles.typeDiv} >
                    <div
                        className={classnames(styles.type, selectType === `alarm` ? styles.select : ``)}
                        onClick={() => { this.typeChange(`alarm`) }}
                    >告警</div>
                    <Divider className={styles.divider} type="vertical" />
                    <div
                        className={classnames(styles.type, selectType === `event` ? styles.select : ``)}
                        onClick={() => { this.typeChange(`event`) }}>事件</div>
                    <Divider className={styles.divider} type="vertical" />
                    <div
                        className={classnames(styles.type, selectType === `action` ? styles.select : ``)}
                        onClick={() => { this.typeChange(`action`) }}>操作</div>
                    <Divider className={styles.divider} type="vertical" />
                    <div
                        className={classnames(styles.type, selectType === `other` ? styles.select : ``)}
                        onClick={() => { this.typeChange(`other`) }}>其他</div>
                </div>
                {log ?
                    <div className={styles.body} >
                        {log}
                    </div>
                    : ``}
            </div>
        )
    }

}

export default Logs